module.exports = __webpack_public_path__ + "img/office_1.a42b6668.gif";